module.exports = __webpack_public_path__ + "facc451c5ea3b11015af55ce05166ecc.png";